import React, { useEffect, useState } from "react";
import { DatePicker } from "antd";
import { CalendarDate } from "../../../types/dataModel";
import { getAPIHeaders, toDateFromEpoch, convertDDMMYYYYToEpochDate, isNotEmpty } from "../../../common/Utils";
import dayjs, { Dayjs } from "dayjs";
import { API } from "../../../common/Constants";
import PreLoader from "../../../core/common/preLoader";
import { Link } from "react-router";
import useFetch from "../../../hooks/useFetch";
import CommonSelectV2 from "../../../core/common/commonSelectV2";

interface Props {
  calendarDate?: CalendarDate
  onSuccess: ()=>void
  onClose: ()=>void
}
const types = [
  { value: "EVENT", label: "Event" },
  { value: "HOLIDAY", label: "Holiday" },
  { value: "PUBLIC_HOLIDAY" , label: "Public Holiday" },
];

const CalendarModal = ({onSuccess, calendarDate, onClose}:Props) => {
    const { isLoading, error, status, callFetch } = useFetch();
    const [formData, setFormData] = useState<CalendarDate>();
    const [showMsgBox, setShowMsgBox] = useState<boolean>(false)
    const [errorMessage, setErrorMessage] = useState<string | undefined>("");

    useEffect(() => {
      if(status && status < 299){
          reset();
          setShowMsgBox(true)
          onSuccess()
      }
    }, [status]);

    useEffect(()=>{
      setFormData(calendarDate)
    },[calendarDate])

    const reset = ()=>{
      setShowMsgBox(false)
      setErrorMessage("")
      setFormData({
        id: undefined,
        description: "",
        type: null,
        startTime: undefined,
        endTime: undefined
      })
    }
    const getModalContainer = () => {
        const modalElement = document.getElementById("modal-datepicker");
        return modalElement ? modalElement : document.body; // Fallback to document.body if modalElement is null
    };

    useEffect(() => {
      if(error){
        if(error.response?.data){
          setErrorMessage(error.response?.data)
        } else{
          setErrorMessage('Something went wrong please try again later.')
        }
        setShowMsgBox(true)
      }
  }, [error]);

 const handleSubmit = (event:any) => {
      event.preventDefault()
      if(!isNotEmpty(formData?.description)){
        setErrorMessage("Please provide description")
      } else if(!isNotEmpty(formData?.type)){
        setErrorMessage("Please select type")
      } else if(!formData?.startTime){
        setErrorMessage("Please select start time")
      }  else if(!formData?.endTime){
        setErrorMessage("Please select end time")
      } else {
        setErrorMessage("")
        callFetch(API.CALENDAR,
            formData.id ? 'PUT' : 'POST',
            getAPIHeaders(),
            null,
            {
                ...formData
            }
        );
      }
  }

  const renderForm = () =>{
    return (
      <div className="modal-content">
        <div className="modal-header">
          <h4 className="modal-title">Edit Holiday</h4>
          <button
            type="button"
            className="btn-close custom-btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            onClick={handleClose}
          >
            <i className="ti ti-x" />
          </button>
        </div>
        <form>
          <div className="modal-body pb-0">
            <div className="row">
              <div className="col-md-12">
                <div className="mb-3">
                  <label className="form-label">Description <span className="text-danger"> *</span></label>
                  <input
                    type="text"
                    className="form-control"
                    defaultValue={formData?.description}
                    value={formData?.description}
                    onChange={(event:any) => {
                      setFormData({
                        ...formData,
                        description: event?.target?.value
                      })
                    }}
                  />
                </div>
              </div>
              <div className="col-md-12">
                <div className="mb-3">
                  <label className="form-label">Type <span className="text-danger"> *</span></label>
                  <CommonSelectV2
                    className="select"
                    options={types}
                    defaultValue={types.find((t)=> t.value === formData?.type)}
                    onChange={(value)=>{
                      setFormData({
                          ...formData,
                          type: value
                      })
                    }}
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="form-label">Start Date <span className="text-danger"> *</span></label>
                  <div className="input-icon-end position-relative">
                  <DatePicker
                      className="form-control datetimepicker"
                      format={{
                        format: "DD-MM-YYYY",
                        type: "mask",
                      }}
                      getPopupContainer={getModalContainer}
                      placeholder="DD-MM-YYYY"
                      value={formData?.startTime ? dayjs(toDateFromEpoch(formData?.startTime)):undefined}
                      onChange={(dt:Dayjs | null, dateString: string | string[]) => {
                        const strDate = Array.isArray(dateString) ? dateString[0] : dateString;
                        const epochTime = dt ? convertDDMMYYYYToEpochDate(strDate) : undefined;
                        setFormData({
                          ...formData,
                          startTime: epochTime === null ? undefined : epochTime
                        })
                      }}
                      disabledDate={(current) => {
                        return current && current < dayjs().startOf('day');
                      }}
                    />
                    <span className="input-icon-addon">
                      <i className="ti ti-calendar text-gray-7" />
                    </span>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="form-label">End Date <span className="text-danger"> *</span></label>
                  <div className="input-icon-end position-relative">
                  <DatePicker
                      className="form-control datetimepicker"
                      format={{
                        format: "DD-MM-YYYY",
                        type: "mask",
                      }}
                      getPopupContainer={getModalContainer}
                      placeholder="DD-MM-YYYY"
                      value={formData?.endTime ? dayjs(toDateFromEpoch(formData?.endTime)):undefined}
                      onChange={(dt:Dayjs | null, dateString: string | string[]) => {
                        const strDate = Array.isArray(dateString) ? dateString[0] : dateString;
                        const epochTime = dt ? convertDDMMYYYYToEpochDate(strDate) : undefined;
                        setFormData({
                          ...formData,
                          endTime: epochTime === null ? undefined : epochTime
                        })
                      }}
                      disabledDate={(current) => {
                        return current && 
                          (formData?.startTime ? current < dayjs(toDateFromEpoch(formData?.startTime)).startOf('day') : current < dayjs().startOf('day'));
                      }}
                    />
                    <span className="input-icon-addon">
                      <i className="ti ti-calendar text-gray-7" />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer d-flex flex-column w-100 gap-2">
            <div className="align-self-start">
              {errorMessage &&
                <>
                  <i className="ti ti-alert-triangle text-danger" />
                  <span className='text-danger'> {errorMessage} </span>
                </>
              }
            </div>
            <div className="align-self-end">
              <button
                type="button"
                className="btn btn-light me-2"
                data-bs-dismiss="modal"
                onClick={handleClose}
              >
                Cancel
              </button>
              <button type="button" className="btn btn-primary"
                onClick={handleSubmit}>
                Save Changes
              </button>
            </div>
          </div>
        </form>
    </div>
    )
  }

  const renderMsgBox = () => {
    return (
    <div className="modal-content">
        <div className="modal-body text-center">
          {
            errorMessage
            ?
            <span className="avatar avatar-xl bg-transparent-danger text-danger mb-3">
                <i className="ti ti-thumb-down fs-36" />
            </span>
            :
            <span className="avatar avatar-xl bg-transparent-success text-success mb-3">
                <i className="ti ti-thumb-up fs-36" />
            </span>
          }

            <h4 className="mb-1">{errorMessage? 'Calander Date Save Failed' : 'Calander Date Save Successfull'}</h4>
            <p className="mb-3">
                {errorMessage ? errorMessage : 'Calander Date is saved successfully.'}
            </p>
            <div className="d-flex justify-content-center">
                <Link to="#" 
                    data-bs-dismiss="modal" 
                    className="btn btn-secondary"
                    onClick={()=>{
                      setTimeout(() => {
                        setShowMsgBox(false);
                      }, 1000);
                      }}>
                    Close
                </Link>
            </div>
        </div>
    </div>
    )
  }

  const handleClose = () => {
    reset();
    onClose();
  }

  return (
    <>
      {/* Edit Plan */}
      <div className="modal fade" id="edit_holiday"
           data-bs-backdrop="static"
           data-bs-keyboard="false">
        <div className="modal-dialog modal-dialog-centered modal-md">
          <PreLoader showLoader={isLoading} />
          {showMsgBox ? renderMsgBox() : renderForm()}
         
        </div>
      </div>
      {/* /Edit Plan */}
    </>
  );
};

export default CalendarModal;
